// @flow

import * as React from 'react';
import uiStore from 'stores/ui';

type Props = {
    [prop: string]: any
};

const LinkSwitcher = (props: Props): React.Node => {
    if (uiStore.isStatic) {
        // eslint-disable-next-line global-require
        const { Link: UiKitLink } = require('@insolus/ui-kit');
        return <UiKitLink {...props} />;
    }
    // eslint-disable-next-line global-require
    const { Link: RouterLink } = require('@insolus/react-router');
    return <RouterLink {...props} />;
};

export default LinkSwitcher;
